import logger from 'loglevel';
import { ALLOWED_METHODS, MESSAGE_TYPE_ACK, MESSAGE_TYPE_INVOKE, MESSAGE_TYPE_REQUEST, MESSAGE_TYPE_RETURN, MESSAGE_TYPE_RETURN_ERROR, isPulseProxyMessage, } from './consts';
import { isBrowser } from '../WebApi';
export function startProxyProviderListener(tracker) {
    if (!isBrowser) {
        logger.debug('Proxy Provider - Not in browser environment, skipping message listener');
        return () => { };
    }
    logger.debug('Proxy Provider - Added message listener for proxy provider');
    const listener = async (event) => {
        logger.debug('Proxy Provider - message received', event.data);
        if (!event.ports.length || !isPulseProxyMessage(event.data)) {
            logger.debug('Proxy Provider - message is not for us, skipping. Data:', event.data, 'Ports:', event.ports);
            return;
        }
        const respond = (message) => {
            logger.debug(`Proxy Provider - response to (${event.origin}): `, message);
            event.ports[0].postMessage(message);
        };
        if (event.data.type === MESSAGE_TYPE_REQUEST) {
            respond({ type: MESSAGE_TYPE_ACK });
        }
        else if (event.data.type === MESSAGE_TYPE_INVOKE) {
            const { method, args } = event.data.payload;
            try {
                if (!ALLOWED_METHODS.includes(method)) {
                    throw new Error(`Method ${method} is not allowed`);
                }
                const result = await tracker[method](...args);
                respond({
                    type: MESSAGE_TYPE_RETURN,
                    payload: result,
                });
            }
            catch (error) {
                respond({
                    type: MESSAGE_TYPE_RETURN_ERROR,
                    error: `${error}`,
                });
            }
        }
    };
    window.addEventListener('message', listener);
    return () => {
        window.removeEventListener('message', listener);
    };
}
